import { Link } from "react-router-dom";
import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import { formatDate, renderAmount } from "../../../../utils";

// Config for Manifest report UI table
const tableConfig = [
  {
    id: "manifestId",
    header: "Manifest ID",
    minWidth: 120,
    cell: ({ getValue, row }) => {
      const value = getValue();
      const rowId = row.original._id;
      if (rowId) {
        return (
          <Link
            to={`/manifests/${rowId}`}
            className="text-primary-600 hover:underline cursor-pointer"
          >
            {value || rowId}
          </Link>
        );
      }
      return value || "-";
    },
  },
  {
    id: "date",
    header: "Date",
    minWidth: 120,
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "driver",
    header: "Driver",
    minWidth: 150,
    cell: ({ getValue }) => {
      const driver = getValue();
      if (!driver) return "-";
      if (typeof driver === "string") return driver;
      return (
        driver?.fullName ||
        `${driver?.firstName || ""} ${driver?.lastName || ""}`.trim() ||
        "-"
      );
    },
  },
  {
    id: "status",
    header: "Status",
    minWidth: 100,
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "totalMileage",
    header: "Total Mileage",
    minWidth: 130,
    cell: ({ getValue }) => {
      const value = getValue();
      if (value === null || value === undefined) return "-";
      return `${value.toLocaleString()} mi`;
    },
  },
  {
    id: "totalDrops",
    header: "Total Drops",
    minWidth: 120,
    cell: ({ getValue }) => {
      const value = getValue();
      if (value === null || value === undefined) return "-";
      return value.toString();
    },
  },
  {
    id: "total",
    header: "Gross",
    minWidth: 120,
    cell: ({ getValue }) => renderAmount(getValue()),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);










